var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 12.2917C9.65833 12.2917 9.375 12.0083 9.375 11.6667V7.5C9.375 7.15833 9.65833 6.875 10 6.875C10.3417 6.875 10.625 7.15833 10.625 7.5V11.6667C10.625 12.0083 10.3417 12.2917 10 12.2917Z",
    fill: "#03182F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99984 15C9.94984 15 9.8915 14.9917 9.83317 14.9834C9.78317 14.975 9.73317 14.9584 9.68317 14.9334C9.63317 14.9167 9.58317 14.8917 9.53317 14.8584C9.4915 14.825 9.44984 14.7917 9.40817 14.7584C9.25817 14.6 9.1665 14.3834 9.1665 14.1667C9.1665 13.95 9.25817 13.7334 9.40817 13.575C9.44984 13.5417 9.4915 13.5084 9.53317 13.475C9.58317 13.4417 9.63317 13.4167 9.68317 13.4C9.73317 13.375 9.78317 13.3584 9.83317 13.35C9.9415 13.325 10.0582 13.325 10.1582 13.35C10.2165 13.3584 10.2665 13.375 10.3165 13.4C10.3665 13.4167 10.4165 13.4417 10.4665 13.475C10.5082 13.5084 10.5498 13.5417 10.5915 13.575C10.7415 13.7334 10.8332 13.95 10.8332 14.1667C10.8332 14.3834 10.7415 14.6 10.5915 14.7584C10.5498 14.7917 10.5082 14.825 10.4665 14.8584C10.4165 14.8917 10.3665 14.9167 10.3165 14.9334C10.2665 14.9584 10.2165 14.975 10.1582 14.9834C10.1082 14.9917 10.0498 15 9.99984 15Z",
    fill: "#03182F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.0497 18.4667H4.94974C3.32474 18.4667 2.08307 17.875 1.44974 16.8083C0.824736 15.7417 0.908069 14.3667 1.69974 12.9417L6.74974 3.85833C7.58307 2.35833 8.73307 1.53333 9.99974 1.53333C11.2664 1.53333 12.4164 2.35833 13.2497 3.85833L18.2997 12.95C19.0914 14.375 19.1831 15.7417 18.5497 16.8167C17.9164 17.875 16.6747 18.4667 15.0497 18.4667ZM9.99974 2.78333C9.2164 2.78333 8.44974 3.38333 7.8414 4.46666L2.79974 13.5583C2.23307 14.575 2.1414 15.5083 2.53307 16.1833C2.92474 16.8583 3.7914 17.225 4.95807 17.225H15.0581C16.2247 17.225 17.0831 16.8583 17.4831 16.1833C17.8831 15.5083 17.7831 14.5833 17.2164 13.5583L12.1581 4.46666C11.5497 3.38333 10.7831 2.78333 9.99974 2.78333Z",
    fill: "#03182F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/hazard.0c3d249792d19b2f23c7018e5a3eba9c.svg";
export { ForwardRef as ReactComponent };